import { render, staticRenderFns } from "./reject.vue?vue&type=template&id=0204e844&scoped=true"
import script from "./reject.ts?vue&type=script&lang=ts&external"
export * from "./reject.ts?vue&type=script&lang=ts&external"
import style0 from "./reject.scoped.scss?vue&type=style&index=0&id=0204e844&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0204e844",
  null
  
)

export default component.exports